module.exports = __webpack_public_path__ + "static/media/IMG_2465.ef33eae8.JPG";